/* eslint-disable no-magic-numbers */
import { ZOOM_IN_LIMIT } from '../../../constants/constants';

export const getZoomMessage = ({
  zoomLevel,
  isPremium,
}: {
  zoomLevel: number;
  isPremium: boolean;
}): string | null => {
  if (zoomLevel < 11) {
    return isPremium
      ? 'Zoom in to see fishing waters and catches'
      : 'Zoom in to see fishing waters';
  }
  if (zoomLevel > 11 && zoomLevel <= 12) {
    return 'Zoom in to explore boat ramps, bait shops and more';
  }
  if (zoomLevel > 12 && zoomLevel < 13) {
    return isPremium ? 'Zoom in to see catch details' : 'Click on water icon to see catch photos';
  }
  if (!isPremium && zoomLevel > ZOOM_IN_LIMIT) {
    return 'Zoom out to see catches in the map area';
  }
  return null;
};
